(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["notificaciones"]) return;
  try {
    
  document.querySelector(".cerrar-noti").addEventListener("click", (e) => {
    document.querySelectorAll(".noti").forEach(box => { box.style.display = "none" })
  });

  } catch(e) { console.error(e); }
})();
})();
